<!-- Stats -->
<div class="main">
	<div class="container stats-container">
		<div class="text-center">
			<div class="row">
				<div class="col-md-12 ml-auto mr-auto">
					<h2 class="title stats-header" title="Statistics published as of June 5, 2022">
						Be Part of the RegScale RegOps Movement!
					</h2>
				</div>
			</div>
			<div class="features">
				<div class="row">
					<div class="col-6 col-md-4">
						<div class="info">
							<!-- <div class="icon icon-github d-none d-md-block">
								<i class="material-icons">file_download</i>
							</div> -->
							<img
								src="../../assets/img/file-dwonload.svg"
								alt=""
							/>
							<h4 class="info-title">285,000+</h4> <!-- C2 Labs Number + RegScale Number -->
							<p class="value">Downloads and Installations</p>
						</div>
					</div>
					<div class="col-6 col-md-4">
						<div class="info">
							<!-- <div class="icon icon-github d-none d-md-block">
								<i class="material-icons">mobile_friendly</i>
							</div> -->
							<img
								src="../../assets/img/features-developed.svg"
								alt=""
							/>
							<h4 class="info-title">2505</h4>
							<p class="value">Features Developed</p>
						</div>
					</div>
					<div class="col-6 col-md-4">
						<div class="info">
							<!-- <div class="icon icon-github d-none d-md-block">
								<i class="material-icons">share</i>
							</div> -->
							<img
								src="../../assets/img/open-source.svg"
								alt=""
							/>
							<!-- Atlasify -->
							<h4 class="info-title">20+</h4>
							<p class="value">Integrations</p><!-- Open Source + COTS -->
						</div>
					</div>
					<div class="col-6 col-md-4">
						<div class="info">
							<!-- <div class="icon icon-github d-none d-md-block">
								<i class="material-icons">launch</i>
							</div> -->
							<img
								src="../../assets/img/software-releases.svg"
								alt=""
							/>
							<h4 class="info-title">127</h4> <!-- 117 in legacy repo + current repo-->
							<p class="value">Software Releases</p>
						</div>
					</div>
					<div class="col-6 col-md-4">
						<div class="info">
							<!-- <div class="icon icon-github d-none d-md-block">
								<i class="material-icons">gavel</i>
							</div> -->
							<img
								src="../../assets/img/regulations-supported.svg"
								alt=""
							/>
							<h4 class="info-title">
								{{ catCount }}
							</h4>
							<p class="value">Regulations Supported</p>
						</div>
					</div>
					<div class="col-6 col-md-4">
						<div class="info">
							<!-- <div class="icon icon-github d-none d-md-block">
								<i class="material-icons">widgets</i>
							</div> -->
							<img
								src="../../assets/img/modules-available.svg"
								alt=""
							/>
							<h4 class="info-title">
								{{ modCount }}
							</h4>
							<p class="value">Modules Available</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
